import React from "react";
import s from "../Calendar.css";
import { FormattedMessage } from "react-intl";
import messages from "../../../locale/messages";

class CalendarHeader extends React.Component {
  render() {
    const { selectedDate, handlePrev, handleNext, loading, listings } =
      this.props;
    return (
      <div
        className={`${s.dFlex} ${s.justifyContentBetween} ${s.alignItemsCenter}  ${s.py2} ${s.positionSticky} ${s.left0}`}
      >
        {loading ? (
          <div className={s.colorBlue}>
            0 <FormattedMessage {...messages.mapListing} />
          </div>
        ) : (
          <div className={s.colorBlue}>
            {listings.length} <FormattedMessage {...messages.mapListing} />
          </div>
        )}

        {/* <h5 className={s.colorBlue}>{selectedDate.format("MMMM YYYY")}</h5> */}
        <div className={`${s.dFlex} ${s.alignItemsCenter} ${s.gap2}`}>
          <button
            className={`btn btn-sm btn-outline-secondary ${s.btnPre}`}
            onClick={handlePrev}
          >
            <span className={s.arrowCust}> 
          ← </span>
          </button>
          <h5 className={`mb-0 ${s.colorBlue}`}>
            {selectedDate.format("MMMM YYYY")}
          </h5>
          <button
            className={`btn btn-sm btn-outline-secondary ${s.btnPre}`}
            onClick={handleNext}
          >
            <span className={s.arrowCust}>
             → </span>
          </button>
        </div>
      </div>
    );
  }
}

export default CalendarHeader;
